import { useEffect, useRef, useState } from "react";
import { Box, TextField } from "@mui/material";
import { useShallow } from "zustand/react/shallow";

import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/whatsappTemplatePreview.module.scss";

import { replacingTemplateMarkdownText } from "../../../../../utils/constants";
import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import { useCarouselFunctions } from "../../utils/useCarouselFunctions";
import { isTemplateCreated } from "../../constant";

const CarouselTemplateCardFooterPreview = (props: any) => {

    const { cardData, cardIndex, editable = false, handleChangeText } = props;

    const { createTemplatePayload } = useTemplateLibraryStore(useShallow((state) => ({
        createTemplatePayload: state.createTemplatePayload,
    })));

    const { handleCarouselCardFooterChange } = useCarouselFunctions();

    const [editingText, setEditingText] = useState(false);
    const footerInputRef = useRef<HTMLInputElement | HTMLTextAreaElement>(null);

    // Constants
    const footerData = cardData?.whatsapp_template_footer?.whatsapp_template_footer_value ?? "";
    const isDisabled = isTemplateCreated(createTemplatePayload);

    // Functions
    const handleFooterAreaClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (editable && !isDisabled) {
            setEditingText(true);
        }
    };

    const renderFooterPreview = () => (
        <>
            <Box
                className={styles.whatsappPreview__footer}
                dir="auto"
            >
                <div
                    className={styles.whatsappPreview__textContentPreview}
                    dangerouslySetInnerHTML={{
                        __html: replacingTemplateMarkdownText(footerData) 
                            || "Enter your footer text here"
                        }}
                />
            </Box>
        </>
    );

    useEffect(() => {
        if (!editable) {
            setEditingText(false);
        }
    }, [editable]);

    useEffect(() => {
        if (editingText && footerInputRef.current) {
            const textTimeout = setTimeout(() => {
                const footerInputElement = footerInputRef.current;
                if (!footerInputElement) return;
                footerInputElement.focus();
                const footerValueLength = footerData.length;
                footerInputElement.setSelectionRange(footerValueLength, footerValueLength);
            }, 0);
            return () => clearTimeout(textTimeout);
        }
    }, [editingText, footerData]);

    if (!editable) {
        return footerData?.trim() ? renderFooterPreview() : null;
    }

    return (
        <>
            {editable ? (
                <div
                    onClick={handleFooterAreaClick}
                    className={styles.whatsappPreview__editableTextFieldWrapper}
                    onMouseLeave={() => setEditingText(false)}
                >
                    {editingText ? (
                        <TextField
                            multiline
                            fullWidth
                            inputProps={{ dir: 'auto' }}
                            inputRef={footerInputRef}
                            InputProps={{ className: styles.whatsappPreview__textInputHoverContainer }}
                            disabled={isDisabled}
                            value={footerData}
                            className={styles.whatsappPreview__footer}
                            onChange={(event: any) => handleCarouselCardFooterChange(event, cardIndex, cardData, handleChangeText)}
                            autoComplete="off"
                            placeholder="Enter template footer"
                        />
                    ) : (
                        renderFooterPreview()
                    )}
                </div>
            ) : (
                renderFooterPreview()
            )}
        </>
    );
};

export default CarouselTemplateCardFooterPreview;